<script setup lang="ts">
import IconTranslate from '~icons/mdi/web'

defineProps<{
  inline?: boolean
}>()

const { locales, locale: currentLocale, setLocale } = useI18n()
const availableLocales = computed(() => locales.value.filter(i => i.code !== currentLocale.value))

const getFlag = (localeCode: string) => {
  const flagMap: Record<string, string> = {
    de: '🇩🇪',
    fr: '🇫🇷',
    en: '🇬🇧',
  }
  return flagMap[localeCode] || '🌐'
}
</script>

<template>
  <!-- For new layout -->
  <template v-if="inline">
    <template v-if="availableLocales.length">
      <v-divider />
      <v-list-item
        v-for="locale in availableLocales"
        :key="locale.code"
        :title="locale.name"
        :data-nav-id="`lang_${locale.code}`"
        @click="setLocale(locale.code)"
      >
        <template #prepend>
          <span class="text-body-1 mr-1">{{ getFlag(locale.code) }}</span>
        </template>
      </v-list-item>
    </template>
  </template>

  <!-- For legacy layout -->
  <v-menu
    v-else
    offset-y
    bottom
  >
    <template #activator="{ props }">
      <v-btn
        v-bind="props"
        variant="text"
        size="small"
        color="white"
        data-track-id="lang_switcher_open"
        icon
      >
        <v-icon size="24" :icon="IconTranslate" />
      </v-btn>
    </template>

    <v-list>
      <v-list-item
        v-for="locale in availableLocales"
        :key="locale.code"
        :data-nav-id="`lang_${locale.code}`"
        @click="setLocale(locale.code)"
      >
        <template #prepend>
          <span class="text-body-1 mr-1">{{ getFlag(locale.code) }}</span>
        </template>
        <v-list-item-title>{{ locale.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
